<template>
  <div>
    <es-form>
      <template #es-form-header>
        <div class="header-container">
          <div class="header-elements">
            <font-awesome-icon :icon="['fas', 'file-edit']" size="lg"/>
          </div>
          <div class="header-elements">
            <h6 class="title">
              Format
            </h6>
          </div>
        </div>
      </template>
      <template #es-form>
        <div class="fields-container">
          <div class="field is-horizontal ">
            <div class="field-label is-normal">
              <label class="label">
                File Format
              </label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <div class="buttons has-addons">
                    <button
                      v-for="(item, index) in filteredDmatchFileFormatOptions"
                      :key="index"
                      class="button no-radius"
                      :class="{'selected-option': formatOptions.dmatchFileFormat === item.option}"
                      @click="selectType( 'dmatchFileFormat', item.option )"
                      :disabled="notSearch && !hasAllFileFormats && item.option !== 'three'"
                    >
                      {{ item.label }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">
                Delimiter
              </label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <div class="buttons has-addons">
                    <button
                      v-for="(item, index) in delimiterOptions"
                      :key="index"
                      class="button no-radius"
                      :class="{'selected-option': formatOptions.delimiter === item.option}"
                      @click="selectType('delimiter', item.option)"
                    >
                      {{ item.label }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">
                Qualifier
              </label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <div class="buttons has-addons">
                    <button
                      v-for="(item, index) in qualifierOptions"
                      :key="index"
                      class="button no-radius"
                      :class="{'selected-option': formatOptions.qualifier === item.option}"
                      @click="selectType('qualifier', item.option)"
                    >
                      {{ item.label }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">
                Date Format
              </label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <div class="select is-half-width">
                    <select
                      class="input is-full-width"
                      v-model="formatOptions.dateFormat"
                    >
                      <option
                        v-for="(item, index) in dateFormatOptions"
                        :key="index"
                        :value="item.option"
                      >
                        {{ item.label }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">
                Include Header/Footer
              </label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <div class="buttons has-addons">
                    <button
                      v-for="(item, index) in includeHFOptions"
                      :key="index"
                      class="button no-radius"
                      :class="{'selected-option': formatOptions.includeHF === item.option}"
                      :disabled="formatOptions.dmatchFileFormat === 'dmindex'"
                      @click="selectType('includeHF', item.option)"
                    >
                      {{ item.label }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </es-form>
  </div>
</template>
<script>
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faPoll,
  faFileEdit,
  faSyncAlt,
  faSort,
} from '@fortawesome/pro-solid-svg-icons';
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsFormActions from '@/components/EsFormActions.vue';
import EsLoader from '@/components/EsLoader.vue';
import DateUtils from '@/mixins/DateUtils';
import moment from 'moment';
import { mapGetters } from 'vuex';

library.add(
  faPoll,
  faFileEdit,
  faSyncAlt,
  faSort,
);

export default {
  components: {
    EsForm,
    EsHeader,
    EsFormActions,
    EsLoader,
  },
  mixins: [DateUtils],
  props: [
    'allowedExtractDownloadTypes',
    'categories',
    'formatOptions',
    'matchStatusOptions',
    'notSearch',
  ],
  watch: {
    dmMatchFileFormat() {
      if (this.formatOptions.dmatchFileFormat === 'dmindex') {
        this.formatOptions.includeHF = false;
      }
    },
    matchStatusId() {
      if (!this.hasAllFileFormats) {
        this.formatOptions.dmatchFileFormat = 'three';
      }
    },
  },
  data() {
    return {
      dmatchFileFormatOptions: [
        { label: 'Version 3.0', option: 'three' },
        { label: 'Version 3.0+', option: 'threeplus' },
        { label: 'DirectMatch Index', option: 'dmindex' },
      ],
      delimiterOptions: [
        { label: 'Tab', option: 'TAB' },
        { label: 'Comma', option: 'COMMA' },
      ],
      qualifierOptions: [
        { label: 'Double Quotes ( " )', option: 'DOUBLE_QUOTES' },
        { label: "Single Quote ( ' )", option: 'SINGLE_QUOTES' },
        { label: 'None', option: 'NONE' },
      ],
      includeHFOptions: [
        { label: 'Yes', option: true },
        { label: 'No', option: false },
      ],
      dateFormatOptions: [
        { label: 'mm/dd/yyyy', option: 'MM/dd/yyyy' },
        { label: 'ISO Format (YYYY-MM-DD)', option: 'YYYY-MM-dd' },
        { label: 'mm/d/yyyy', option: 'MM/d/yyyy' },
        { label: 'm/d/yyyy', option: 'M/d/yyyy' },
        { label: 'm/dd/yyyy', option: 'M/dd/yyyy' },
      ],
    };
  },
  methods: {
    selectType(field, option) {
      if (field === 'dmatchFileFormat') {
        this.formatOptions.dmatchFileFormat = option;
      }
      if (field === 'delimiter') {
        this.formatOptions.delimiter = option;
      }
      if (field === 'qualifier') {
        this.formatOptions.qualifier = option;
      }
      if (field === 'includeHF') {
        this.formatOptions.includeHF = option;
      }
    },
  },
  computed: {
    ...mapGetters([
      'user',
    ]),
    hasAllFileFormats() {
      if (this.categories.length) {
        const validCategories = this.categories
          .filter(category => (category.name === 'Match'
              || category.name === 'No Match'));

        if (validCategories.length) {
          let validIds;
          for (let x = 0; x < validCategories.length; x++) {
            if (validCategories[x].data) {
              validIds = validCategories[x].data.map(completed => completed.statType);
              if (validIds.includes(this.matchStatusOptions.matchStatusSelect)) {
                return true;
              }
            }
          }
        }
        return false;
      }
      return false;
    },
    filteredDmatchFileFormatOptions() {
      let allowedArray = [];
      try {
        allowedArray = JSON.parse(this.allowedExtractDownloadTypes) || [];
      } catch {
        allowedArray = [];
      }

      const allowedSet = new Set(allowedArray.map(type => type.toLowerCase()));
      return this.dmatchFileFormatOptions.filter(option => allowedSet.has(option.option.toLowerCase()));
    },
    matchStatusId() {
      return this.matchStatusOptions.matchStatusSelect;
    },
    dmMatchFileFormat() {
      return this.formatOptions.dmatchFileFormat;
    },
  },
};
</script>

  <style lang="sass" scoped>
    .margin-bottom
      margin-bottom: 1rem
    .sort-by
      padding-right: 18px
      position: relative
      color: #777
      text-decoration: none
      &:before, &:after
      border: 4px solid transparent
      content: ""
      display: block
      height: 0
      right: 5px
      top: 50%
      position: absolute
      width: 0
      &:before
        border-bottom-color: #999
        margin-top: -9px
        &:after
          border-top-color: #999
          margin-top: 1px
    .header-container
      margin-bottom: 1rem
    .no-radius
      border-radius: 0
      background-color: #F2F2F2
      font-weight: normal
    .selected-option
      background-color: #ccc
      font-weight: bold
    .fields-container
      margin-left: 30px
    .text-align--left
      text-align: left !important
    .column-header
      padding-left: 0px
    .text-align--right
      text-align: right !important
    .text-align--left
      text-align: left !important
  </style>
